import { Injectable } from "@angular/core";
import { StorageKey } from "@models/StorageKey";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  setItem<T>(key: StorageKey, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getBoolean(key: StorageKey): boolean | null {
    const value = this.getItem(key);
    return typeof value === "boolean" ? value : null;
  }

  getNumber(key: StorageKey): number | null {
    const value = this.getItem(key);
    return typeof value === "number" && !isNaN(value) ? value : null;
  }

  getString(key: StorageKey): string | null {
    const value = this.getItem(key);
    return typeof value === "string" ? value : null;
  }

  getDate(key: StorageKey): Date | null {
    const stringDate = this.getString(key);
    return stringDate ? new Date(stringDate) : null;
  }

  getObject<T>(key: StorageKey): T | null {
    const value = this.getItem(key);
    return typeof value === "object" && value !== null ? (value as T) : null;
  }

  private getItem<T>(key: StorageKey): T | null {
    const value = localStorage.getItem(key);

    if (!value) {
      return null;
    }

    try {
      return JSON.parse(value) as T;
    } catch (e) {
      console.log("Error parsing JSON from localStorage", e);
      return null;
    }
  }
}
